module.exports = __webpack_public_path__ + "media/images/ui-icons_cd0a0a_256x240-459791cd7103af739d3535ffe7528da8.png";